<div class="logout-screen">
  <img src="../../../../../assets/logo.png" alt="file my visa logo">
  <h4>Logged Out</h4>
  <p>
    You were successfully logged out
  </p>
  <button mat-stroked-button color="primary" (click)="logIn()">Log In</button>
</div>
